import { computed, unref } from "vue";

export function getRoleLabel(role, lang, options = {}) {
  const normalizedRole = String(role || "").toLowerCase();
  const isAr = String(lang || "").toLowerCase() === "ar";
  const fallback =
    options.fallback ?? (isAr ? "مستخدم" : "User");

  if (!normalizedRole) return fallback;

  if (normalizedRole.includes("office"))
    return isAr ? "مكتب استشاري" : "Consulting Office";
  if (normalizedRole.includes("consultant"))
    return isAr ? "مستشار" : "Consultant";
  if (normalizedRole.includes("client"))
    return isAr ? "عميل" : "Client";
  if (normalizedRole.includes("manager"))
    return isAr ? "مدير الاستشارات" : "Consulting Manager";

  return fallback;
}

export function useRoleLabel(roleRef, langRef, options = {}) {
  return computed(() => getRoleLabel(unref(roleRef), unref(langRef), options));
}
